/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Form, Input, Select } from "antd";
import { FormInstance } from "antd/lib";

import { useAppSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledForm } from "./Styled";

export interface RouteEditorFormValues {
    routeName: string;
    routeAgent: string;
}

export default function RouteEditorForm({
    form,
    showAgentField = true,
}: {
    form: FormInstance<RouteEditorFormValues>;
    showAgentField?: boolean;
}) {
    const { team } = useAppSelector((state) => state.manager);

    const options = team?.members
        ?.filter((member) => member.userId != undefined)
        ?.map(({ userInfo, userId }) => ({
            label: userInfo.fullName,
            value: userId,
        }));

    return (
        <StyledForm form={form} layout="vertical">
            <Form.Item
                label={<PrimaryText>Введіть назву нового маршруту</PrimaryText>}
                name="routeName"
                rules={[{ required: true, message: "Введіть назву маршруту" }]}
            >
                <Input placeholder="Введіть назву маршруту" size="large" />
            </Form.Item>

            {showAgentField && (
                <Form.Item
                    label={<PrimaryText>Оберіть виконавця</PrimaryText>}
                    name="routeAgent"
                    rules={[{ required: true, message: "Оберіть виконавця" }]}
                >
                    <Select placeholder="ПІБ" size="large" options={options} />
                </Form.Item>
            )}
        </StyledForm>
    );
}
